import { FC, memo, useCallback, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IonRouterLink } from '@ionic/react'

import { UserName } from '@/components/atoms/UserName'

import { appConfig } from '@/services/config'

const ConversationWidgetComponent: FC<{
  url: string
  imageUrl: string
  title: string
  username: string
  userId: string
}> = ({ url, imageUrl, title, username, userId }) => {
  const { t } = useTranslation('common')
  const imageRef = useRef<HTMLImageElement>(null)
  const [imageWidth, setImageWidth] = useState(16)

  const measureImageWidth = useCallback(() => {
    if (imageRef !== null && imageRef.current.naturalHeight > 0) {
      setImageWidth(
        (imageRef.current.naturalWidth * 212) /
          imageRef.current.naturalHeight /
          16
      )
    }
  }, [])

  return (
    <>
      <IonRouterLink routerLink={`/${url}`}>
        <div
          className="text-center mb-4 h-[13.25rem]"
          style={{ width: `${imageWidth}rem` }}
        >
          <img
            alt={title}
            ref={imageRef}
            className="object-cover max-h-full rounded-[0.6rem] min-h-[1px] min-w-[1px]"
            onLoad={measureImageWidth}
            src={`${appConfig.cdn}/${imageUrl}/x2.jpeg`}
          />
        </div>
      </IonRouterLink>
      <span
        style={{ maxWidth: `${imageWidth}rem` }}
        className="text-xs block whitespace-nowrap text-white text-ellipsis overflow-hidden w-full text-left"
      >
        #{title}
      </span>
      <span
        style={{ maxWidth: `${imageWidth}rem` }}
        className="flex text-xs whitespace-nowrap text-ellipsis overflow-hidden w-full text-left"
      >
        <span className="inline-block mr-1 text-cool-gray-200">
          {t('common.by')}
        </span>
        <strong>
          <UserName
            userId={userId}
            name={username}
            className="text-cool-gray-200"
          />
        </strong>
      </span>
    </>
  )
}

export const ConversationWidget = memo(ConversationWidgetComponent)
